/*
 * This utility function is currently inactive until further testing on Safari.
 */
export const fixDateForAllBrowsers = dateString => {
  const parts = dateString.split(/\D/)
  return new Date(Date.UTC(parts[2], parts[0] - 1, parts[1], 11, 0, 0, 0))
}
